





































import { ListModel } from "@/shared/models/listModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Notification } from "@/store/modules/notifications";
import { AccomodationUnitTypesWithDetailsView } from "@/shared/models/accomodationUnitTypesWithDetailsView";
import AccomodationUnitTypeTile from "./AccomodationUnitTypeTile.vue";

@Component({
  components: {
    AccomodationUnitTypeTile,
  },
})
export default class AccomodationUnitTypeTiles extends Vue {
  @Prop() propertyId?: number;
  @Prop() propertyCategoryId?: number;

  unitTypes: AccomodationUnitTypesWithDetailsView[] = [];

  loading = false;

  @Watch("propertyId", { immediate: true })
  load() {
    this.loading = true;
    if (!this.propertyId) {
      this.loading = false;
      return;
    }

    this.axios
      .get<ListModel<AccomodationUnitTypesWithDetailsView>>(
        `/properties/${this.propertyId}/AccomodationUnitTypes`
      )
      .then(({ data }) => (this.unitTypes = data.result))
      .finally(() => (this.loading = false));
  }

  add() {
    this.$router.push({
      name: "New unit type",
      params: {
        propertyId: this.propertyId?.toString() ?? "",
        propertyCategoryId: this.propertyCategoryId?.toString() ?? ""
      },
    });
  }

  update(unitType: AccomodationUnitTypesWithDetailsView) {
    this.$router.push({
      name: "Edit unit type",
      params: {
        propertyId: this.propertyId?.toString() ?? "",
        unitTypeId: unitType.id.toString(),
      },
    });
  }

  remove(id: number) {
    Vue.axios
      .delete(`/properties/${this.propertyId}/AccomodationUnitTypes/${id}`)
      .then(() => {
        this.unitTypes = this.unitTypes.filter((x) => x.id !== id);
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("AccomodationUnitType.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      });
  }
}
